import React, { useState } from 'react';
import { LoginForm } from './LoginForm';
import { SignUpForm } from './SignUpForm';
import { FederatedLoginForm } from './FederatedLoginForm';
import { AuthLayout } from './AuthLayout';

export const AuthScreen = ({ onSuccess }) => {
  const [mode, setMode] = useState('federated'); // 'federated', 'login', or 'signup'

  return (
    <AuthLayout mode={mode}>
      {mode === 'signup' ? (
        <SignUpForm
          onSwitchToLogin={() => setMode('login')}
          onSuccess={onSuccess}
        />
      ) : mode === 'login' ? (
        <LoginForm
          onSwitchToFederated={() => setMode('federated')}
          onSuccess={onSuccess}
        />
      ) : (
        <FederatedLoginForm
          onSwitchToLocal={() => setMode('login')}
        />
      )}
    </AuthLayout>
  );
};
